import XrefDialogueButton from './XrefDialogueButton';

export default XrefDialogueButton;
